import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, Text, Tooltip } from '@reveni-io/reveni-ui'

import { issueRefundOptions } from './constants'

const IssueRefundComboBox = ({ checked, onChange, canEditIssueRefund }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleIssueRefundChange = e => onChange(e.target.value === issueRefundOptions.issueRefund)

  return (
    <Tooltip
      backgroundColor={theme.colors.text.default}
      title={
        canEditIssueRefund ? (
          ''
        ) : (
          <Text type="bodySRegular" color={theme.colors.text.inverse}>
            {t('No tienes permiso para emitir reembolsos. El reembolso se gestionará manualmente.')}
          </Text>
        )
      }
    >
      <div>
        <ComboBox
          label={t('Gestión del reembolso')}
          value={checked ? issueRefundOptions.issueRefund : issueRefundOptions.noIssueRefund}
          handleChange={handleIssueRefundChange}
          disabled={!canEditIssueRefund}
          fullWidth
          menuItems={[
            { label: t('Emitir reembolso al confirmar cambios'), value: issueRefundOptions.issueRefund },
            { label: t('Gestionar reembolso manualmente'), value: issueRefundOptions.noIssueRefund },
          ]}
        />
      </div>
    </Tooltip>
  )
}

export default IssueRefundComboBox
